<template>
  <div v-if="show" class="mobile-search-bar d-md-none">
    <b-input-group class="search-input-group">
      <b-form-input
        ref="input"
        :value="value"
        :placeholder="placeholder"
        class="search-input"
        @input="$emit('input', $event)"
        @keyup.enter="$emit('search')"
        @keyup.esc="$emit('close')"
      />
      <b-input-group-append>
        <b-button
          variant="none"
          class="search-button"
          :aria-label="lang !== 'ENG' ? '검색' : 'Search'"
          @click="$emit('search')"
        >
          <b-icon icon="search" />
        </b-button>
        <b-button
          variant="none"
          class="search-button mobile-search-close"
          :aria-label="lang !== 'ENG' ? '검색 닫기' : 'Close search'"
          @click="$emit('close')"
        >
          <b-icon icon="x-lg" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
/**
 * md 미만 화면 전용 검색 입력바. navbar 바로 아래(top: 90px)에 fixed 위치로 노출된다.
 *
 * 기존 inline 검색창(`.d-none.d-md-flex`)은 md+ 에서만 보이므로 모바일에서는
 * 이 컴포넌트가 검색 UI를 담당한다.
 *
 * - v-model로 검색어 양방향 바인딩
 * - @search: 검색 실행 (enter 또는 검색 버튼 클릭)
 * - @close: 검색바 닫기 (esc 또는 X 버튼)
 * - focus(): 부모가 ref로 호출하여 입력 필드에 포커스
 */
export default {
  name: 'MobileSearchBar',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: 'KOR'
    }
  },
  methods: {
    focus() {
      const inputRef = this.$refs.input;
      if (inputRef && typeof inputRef.focus === 'function') {
        inputRef.focus();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-search-bar {
  position: fixed;
  top: 90px;
  left: 0;
  right: 0;
  z-index: 1045;
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid lightgray;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  .search-input-group {
    max-width: 100%;
    border: 1px solid gray;
    border-radius: 25rem;
    overflow: hidden;
  }

  .search-input {
    border: none;
    border-radius: 0;
    font-size: 16px; // iOS Safari 자동 줌 방지
    padding: 8px 16px;
  }

  .search-input:focus {
    box-shadow: none;
  }

  .search-button {
    border: none;
    border-radius: 0;
    background-color: transparent;
    padding: 8px 14px;
  }

  .search-button:hover {
    background-color: #00000011;
  }
}
</style>
